import { Ref, ref } from 'vue'

export function useDynamicPhoneNumber(defaultPhone: string): { phone: Ref<string>, url: Ref<string> } {
	return {
		phone: ref(defaultPhone),
		url: ref(`tel:${defaultPhone}`),
	}
}
